import Image from 'next/image'
import { FC } from 'react'

import { MobileMenuGroup, StackMenuGroup } from '@/sections/NavBar/MenuGroup'

const solutions = [
    {
        url: '/gryn-for-shippers',
        label: 'Enterprise shippers',
        img: (
            <Image
                width={87}
                height={60}
                src={`/illustrations/menu-tile-images/stamp-gryn.png`}
                alt={`Enterprise shippers`}
            />
        ),
    },
    {
        url: '/logistics',
        label: 'Logistics providers',
        img: (
            <Image
                width={87}
                height={60}
                src={`/illustrations/menu-tile-images/stamp-logistics.png`}
                alt={`Logistics providers`}
            />
        ),
    },
]

export const SolutionsDesktopMenu: FC = () => {
    return <StackMenuGroup items={solutions} width={400} />
}

export const SolutionsMobileMenu: FC<{ onClose: () => void }> = ({ onClose }) => {
    return <MobileMenuGroup items={solutions} onClose={onClose} />
}
